module.exports = __webpack_public_path__ + "images/fa-resources-center-offer-bg.jpg";